(() => {
  if (customElements.get('sc-product-view')) return;
  class ProductView extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('click', event => {
        const action = event.target.closest('[data-view-action]')?.dataset.viewAction;
        if (action === '3d') this.showModel();
        if (action === 'photo') this.showPhoto();
        if (action === 'reset') this.viewer?.reset();
      }, { signal: this.abort.signal });
      this.mode = 'photo';
      this.querySelector('[data-product-controls]').hidden=!this.dataset.model;
      this.querySelector('[data-view-action="photo"]').hidden=true;
    }
    disconnectedCallback() { this.abort?.abort(); this.viewer?.dispose(); this.viewer=null; this.generation=(this.generation||0)+1; }
    sync(source) {
      const had3d=this.mode==='3d';
      this.disconnectedCallback();
      this.innerHTML=source.innerHTML;
      for (const key of Object.keys(this.dataset)) delete this.dataset[key];
      Object.assign(this.dataset,source.dataset);
      this.connectedCallback();
      if (had3d && this.dataset.model) this.showModel();
    }
    showPhoto() {
      this.mode='photo'; this.generation=(this.generation||0)+1;
      this.viewer?.dispose(); this.viewer=null;
      this.querySelector('[data-product-canvas]').replaceChildren();
      this.querySelector('[data-product-canvas]').hidden=true;
      this.querySelector('[data-product-still]').hidden=false;
      this.querySelector('[data-view-action="reset"]').hidden=true;
      this.querySelector('[data-view-action="photo"]').hidden=true;
      this.querySelector('[data-view-action="photo"]').setAttribute('aria-pressed','true');
      this.querySelector('[data-view-action="3d"]').setAttribute('aria-pressed','false');
      this.querySelector('[data-product-hint]').textContent=this.dataset.model?'Explore the shape with a 3D view.':'';
    }
    async showModel() {
      if (!this.dataset.model || this.mode==='loading' || this.mode==='3d') return;
      const generation=this.generation=(this.generation||0)+1;
      const hint=this.querySelector('[data-product-hint]');
      this.mode='loading';hint.textContent='Loading 3D view…';
      try {
        const { createProductViewer } = await import(this.dataset.viewer);
        if (generation!==this.generation || !this.isConnected) return;
        const viewer=await createProductViewer(this.querySelector('[data-product-canvas]'),this.dataset);
        if (generation!==this.generation || !this.isConnected) {viewer.dispose();return;}
        this.viewer=viewer; this.mode='3d';
        this.querySelector('[data-product-still]').hidden=true;
        this.querySelector('[data-product-canvas]').hidden=false;
        viewer.resize();
        this.querySelector('[data-view-action="reset"]').hidden=false;
        this.querySelector('[data-view-action="photo"]').hidden=false;
        this.querySelector('[data-view-action="photo"]').setAttribute('aria-pressed','false');
        this.querySelector('[data-view-action="3d"]').setAttribute('aria-pressed','true');
        hint.textContent='Drag left or right to rotate. Arrow keys rotate; + / − zoom. Mount only; equipment and fixings are not shown.';
      } catch(error) {
        if (generation!==this.generation) return;
        this.showPhoto(); hint.textContent='3D could not load. Your selected product image is still available.';
      }
    }
  }
  customElements.define('sc-product-view',ProductView);
})();
